import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions, RequestMethod } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class LoginService {
    headers: Headers;
    options: RequestOptions;
    baseAPIurl: string = '';
    baseUrlForToken: string = '';
    public IsForgetPassword = false;

    constructor(private _http: Http, private _httpClient: HttpClient) {
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        var Token = localStorage.getItem("AccessToken");
        this.headers.append("Authorization", "Bearer " + Token);
        this.options = new RequestOptions({ headers: this.headers });
        this.baseAPIurl = environment.baseAPIUrl;
        this.baseUrlForToken = environment.APIUrlForToken
    }

    InsertRegistrationData(RegistartionRecord) {
        return this._http.post(this.baseAPIurl + "Registration/InsertRegistrationData", RegistartionRecord)
    }

    GetRole() {
        return this._http.get(this.baseAPIurl + "Registration/GetRole", this.options)
    }

    AuthenticateLogin(UserName) {
        return this._http.get(this.baseAPIurl + "Login/AuthenticateLogin?EmailId=" + UserName, this.options)

    }

    TokenAuthentication(UserName, Password) {
        let urlSearchParams = new URLSearchParams();
        urlSearchParams.set('grant_type', 'password');
        urlSearchParams.set('username', UserName);
        urlSearchParams.set('password', Password);
        let body = urlSearchParams;

        return this._http.post(this.baseUrlForToken + "token", body)
    }

    GetAccountDetails(UserId) {
        return this._http.get(this.baseAPIurl + "Registration/GetAccountDetails?UserId=" + UserId, this.options);

    }

    GenerateEmail(UserId) {
        return this._http.get(this.baseAPIurl + "IdentityMail/GenerateEmail?UserId=" + UserId, this.options);
    }

    IsEMailId(EMailId) {
        return this._http.get(this.baseAPIurl + "Registration/IsEMailId?EMailId=" + EMailId);
    }

    ValidateEMailId(token) {
        return this._http.get(this.baseAPIurl + "Registration/VaidateEmail?token=" + token);
    }

    ReleaseToken() {
        return this._http.get(this.baseAPIurl + "Login/ReleaseToken", this.options);
    }

    VerifyEmailForRunBackgroundCheck(Id) {
        return this._http.get(this.baseAPIurl + "IdentityMail/VerifyEmailForRunBackgroundCheck?Id=" + Id, this.options);
    }

    GenerateEmailForForgetPassword(EmailId) {
        return this._http.get(this.baseAPIurl + "IdentityMail/GenerateEmailForForgetPassword?EmailId=" + EmailId, this.options);
    }








};